// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const Play: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.219 13.438 8.06 20.629a1.907 1.907 0 0 1-2.707-.465A2.034 2.034 0 0 1 5 19.191V4.809c.1-1.097 1.046-1.903 2.113-1.801.342.034.668.159.947.363l10.159 7.191c.773.49 1.012 1.531.536 2.325a1.661 1.661 0 0 1-.536.551z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const PlayOffset: IconOffset = {
    vertical: 12,
    horizontal: 20,
};

export default React.memo(Play);
